import { PropsWithChildren } from "react";

export const UnitLandingWrapper: React.FC<PropsWithChildren> = ({
  children,
}) => <div className="flex w-full flex-col gap-2">{children}</div>;
